
/**
 * @export
 * @enum {string}
 */
export enum SupportedSsoProvider {
    OKTA = 'OKTA',
    AUTH0 = 'AUTH0',
    PING_FEDERATE = 'PING_FEDERATE',
    ONE_LOGIN = 'ONE_LOGIN',
    GOOGLE_WORKSPACE = 'GOOGLE_WORKSPACE',
    MICROSOFT_ENTRA = 'MICROSOFT_ENTRA',
    OTHER = 'OTHER'
}